import { Not, NumberGreaterThan } from '@vendasta/automata';
import { DataFilter } from './interface';
import { CurrencyInputComponent } from './dynamic-options/currency-input/currency-input.component';
import { CurrencyInputDisplayService } from './dynamic-options';

const WHOLESALE_PRICE = '{.wholesale_price}';
class WholesalePriceFilter implements DataFilter {
  rules = [new Not(new NumberGreaterThan(WHOLESALE_PRICE)), new NumberGreaterThan(WHOLESALE_PRICE)];
  dataEntryComponentList = [CurrencyInputComponent, CurrencyInputComponent];
  displayService = CurrencyInputDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.PRODUCT_PRICE_DATA.DATA_LABELS.WHOLESALE_PRICE';
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.PRODUCT_PRICE_DATA.COMPARISON.LESS_THAN_EQUAL',
    'AUTOMATIONS.EDITOR.FILTERS.PRODUCT_PRICE_DATA.COMPARISON.GREATER_THAN',
  ];
}

export const PRODUCT_PRICE_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [WHOLESALE_PRICE, new WholesalePriceFilter()],
]);
